module.exports = __webpack_public_path__ + "media/teacher/components/GetStarted/images/PT G1-803f9384f485cfaa8134e3246e9d6b5d.gif";